import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App';
import './index.css';

/**
 * Despliegues nuevos con la web ya abierta.
 *
 * Cada despliegue cambia el nombre de los archivos JS de cada página. Quien
 * tenía la web abierta desde antes y toca el menú pide el archivo VIEJO, que
 * ya no existe (404), y la navegación muere en silencio: el menú "no lleva".
 * Vite avisa con este evento. Para entonces la URL ya es la de destino, así
 * que recargar trae la versión nueva y abre justo la página pedida.
 *
 * El candado de 10 s evita un bucle de recargas si un archivo faltara de
 * verdad en la versión nueva.
 */
window.addEventListener('vite:preloadError', (event) => {
  const CLAVE = 'recarga-por-despliegue';
  let ultima = 0;
  try {
    ultima = Number(sessionStorage.getItem(CLAVE) || 0);
  } catch {
    /* almacenamiento bloqueado (algunos modos privados): se recarga igual */
  }
  if (Date.now() - ultima < 10_000) return;
  try {
    sessionStorage.setItem(CLAVE, String(Date.now()));
  } catch {
    /* idem */
  }
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * En producción el HTML llega con el contenido ya renderizado por
 * `scripts/prerender.mjs`, así que hay que HIDRATARLO (enganchar React al DOM
 * existente) en vez de volver a pintarlo desde cero.
 *
 * En `npm run dev` el contenedor está vacío, y llamar a `hydrateRoot` sobre un
 * contenedor vacío es un error. Por eso se decide mirando si hay contenido:
 * así el mismo fichero sirve para desarrollo y para producción.
 */
if (rootElement.hasChildNodes()) {
  hydrateRoot(rootElement, app);
} else {
  createRoot(rootElement).render(app);
}
